import { displayPrice } from "@/lib/utils";

interface CashChangeDisplayProps {
  cashTendered: number;
  amount: number;
  /** Tip kept from the tendered cash (cents). Reduces the change. */
  tipAmount?: number;
  currency: string;
}

const CashChangeDisplay: React.FC<CashChangeDisplayProps> = ({
  cashTendered,
  amount,
  tipAmount = 0,
  currency,
}) => {
  const due = amount + tipAmount;
  if (!cashTendered || cashTendered <= due) {
    return null;
  }

  const change = cashTendered - due;

  return (
    <div className="rounded-lg bg-green-50 border border-green-200 px-3 py-2.5 flex items-center justify-between">
      <span className="text-sm text-muted-foreground">Monnaie à rendre</span>
      <span className="text-sm font-semibold text-green-600">
        {displayPrice(change, currency)}
      </span>
    </div>
  );
};

export default CashChangeDisplay;
